import { RecordPageView } from '../viewManagerTypes';
import { ViewApi } from './Common/ViewApi';


export class RecordPageViewApi extends ViewApi<RecordPageView> {
    urlPath: string = '/grid-view/page';
}
